export default "__VITE_ASSET__Ds1WYIVC__";